import { SearchField as SearchFieldCore } from '@tink/core/src/components/atoms/SearchField/SearchField';
import { alpha } from '@material-ui/core/styles';
import { styled } from '../../../core/theme/styled';

export const SearchField = styled(SearchFieldCore)`
  && {
    flex-shrink: 0;
    background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
    margin-bottom: ${(props) => props.theme.sizes.normedium};
    border-radius: ${({ theme }) => theme.roundedCorners.xsmall};
    border: 1px solid transparent;

    &:focus-within,
    &:hover {
      border-color: ${({ theme }) => alpha(theme.configuration.primaryTextColor, 0.5)};
    }

    &:focus-within {
      box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.configuration.primaryColor, 0.25)};
    }

    .MuiInputAdornment-root {
      svg {
        font-size: ${({ theme }) => theme.sizes.normal};
        fill: ${({ theme }) => theme.configuration.secondaryTextColor};
      }
    }

    input {
      height: auto;
      color: ${({ theme }) => theme.configuration.primaryTextColor};
      line-height: 1.2;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

      &::placeholder {
        color: ${({ theme }) => theme.configuration.secondaryTextColor};
        opacity: 1;
      }
    }
  }
`;
